import React, { useState } from "react";
import PropTypes from "prop-types";
import { Title, Fieldset, Button, Control, Field } from "rbx";
import { useMutation } from "react-apollo";

import { CREATE_ITEM_CATEGORY_MUTATION } from "../../graphql/ItemCategories/ItemCategories.graphql";
import { ourToast as toast } from "../../utils";

import ItemForm from "./ItemCategoryForm";

const DEFAULT_STATE = {
  Active: true,
  Description: "",
  ItemCatgCd: "",
  InspectionCdRecIdRef: null,
  ItemCatgTypeRecIdRef: null
};

const AddItemCategory = ({ onComplete }) => {
  const [inputs, setInputs] = useState({ ...DEFAULT_STATE });
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const updates = { ...inputs };
    if (
      e.target.name.includes("InspectionCdRecIdRef") ||
      e.target.name.includes("ItemCatgTypeRecIdRef")
    ) {
      updates[e.target.name] = parseInt(value);
    } else {
      updates[e.target.name] = value;
    }
    setInputs({ ...updates });
  };
  const [createItemCategory, { loading }] = useMutation(
    CREATE_ITEM_CATEGORY_MUTATION,
    {
      refetchQueries: [
        "ALL_ITEM_CATEGORIES_QUERY",
        "SINGLE_ITEM_CATEGORY_QUERY"
      ]
    }
  );
  const handleSave = async e => {
    e.preventDefault();
    try {
      await createItemCategory({
        variables: {
          data: {
            ...inputs,
            InspectionCdRecIdRef:
              inputs.InspectionCdRecIdRef &&
              parseInt(inputs.InspectionCdRecIdRef),
            ItemCatgTypeRecIdRef:
              inputs.ItemCatgTypeRecIdRef &&
              parseInt(inputs.ItemCatgTypeRecIdRef)
          }
        }
      });
      toast.success("Item Category created successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error creating Item Category.");
    }
  };
  return (
    <form className="add-item-form" id="add-item-form" onSubmit={handleSave}>
      <Title>Create Item Category</Title>
      <Fieldset disabled={loading}>
        <ItemForm inputs={inputs} onChange={handleChange} />
        <hr />
        <Field kind="group">
          <Control>
            <Button color="primary" form="add-item-form" type="submit">
              Submit
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={onComplete}>
              Cancel
            </Button>
          </Control>
        </Field>
      </Fieldset>
    </form>
  );
};

AddItemCategory.propTypes = {
  onComplete: PropTypes.func
};
export default AddItemCategory;
